import { DossierConfigService } from "@/services/dossier-config-service";
import { SaleService } from "@/services/sale-service";

export function isSaleTypeAllowedForBankBookings(typeID:number):boolean {
	let type = SaleService.getAllTypes().find(t => t.ID == typeID);
	if (type && type.ContactGroupID != 1) {
		return true;
	}
	return DossierConfigService.getBankConfig().isSaleTypeAllowedForBookings(typeID);
}
